import type { UnsubscribeRequest } from "@/modules/events/types/eventDetailsApi"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH, UNSUBSCRIBE_ENDPOINT } from "@/modules/events/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

export const getUnsubscribe = async (params: UnsubscribeRequest): Promise<void> => {
  const { locale, hostname, id } = params

  return fetcher(`/${locale}${EVENT_DETAILS_PATH}${id}${UNSUBSCRIBE_ENDPOINT}`, {
    hostname,
    serviceDomain: "MONOLITH_API",
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(UNSUBSCRIBE_ENDPOINT, params))
}
